/** Project onto the nearest 45° ray; axis-aligned drawing retains its length. */
export function constrainDrawingPoint(start, point, enabled) {
  if (!enabled || !start || !point) return point;
  const dx = point.x - start.x, dz = point.z - start.z;
  const step = Math.round(Math.atan2(dz, dx) / (Math.PI / 4));
  const directions = [[1, 0], [1, 1], [0, 1], [-1, 1], [-1, 0], [-1, -1], [0, -1], [1, -1]];
  const [x, z] = directions[(step + 8) % 8];
  const length = (dx * x + dz * z) / (x * x + z * z);
  return { x: start.x + x * length, z: start.z + z * length };
}

export function pointOnDrawingRay(start, point, constrained) {
  const dx = constrained.x - start.x, dz = constrained.z - start.z;
  const length = Math.hypot(dx, dz);
  return length > 0 && Math.abs(dx * (point.z - start.z) - dz * (point.x - start.x)) / length < 1e-6
    && dx * (point.x - start.x) + dz * (point.z - start.z) >= 0;
}
